import { Binary, load } from 'scrivito';

export async function formatObj(obj: Record<string, unknown>): Promise<string> {
  const widgetPool = (obj._widget_pool ?? {}) as Record<string, unknown>;

  const formatted = await formatContent(widgetPool, obj);

  return formatted;
}

async function formatContent(
  widgetPool: Record<string, unknown>,
  content: Record<string, unknown>,
): Promise<string> {
  const entries = (
    await Promise.all(
      Object.entries(content).map(async ([key, data]) => {
        if (key.startsWith('_')) return;
        if (!Array.isArray(data)) return;

        const [type, value] = data;

        switch (type) {
          case 'binary':
            return load(() =>
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore private API
              new Binary(value.id).raw().metadata().get('text'),
            );

          case 'html':
          case 'string': {
            const text = String(value);

            // heuristic: anything too short is likely a technical identifier
            if (text.length < 4) return;

            return text;
          }

          case 'widgetlist':
            if (!Array.isArray(value)) return;

            return (
              await Promise.all(
                value.map(async (id) => {
                  if (typeof id !== 'string') {
                    throw Error('Expected widget ID to be a string');
                  }

                  return formatWidget(widgetPool, id);
                }),
              )
            ).join('\n');
        }
      }),
    )
  )
    // TODO better to use our isPresent function
    .filter(Boolean) as string[];

  if (entries.length === 0) return '';
  if (entries.length === 1) return entries[0];

  return entries.join('\n');
}

async function formatWidget(
  widgetPool: Record<string, unknown>,
  widgetId: string,
): Promise<string> {
  const widget = (widgetPool as Record<string, unknown>)[widgetId];
  if (widget === null || typeof widget !== 'object') return '';

  return formatContent(widgetPool, widget as Record<string, unknown>);
}
